import { FileOutlined } from '@ant-design/icons'
import { FC } from 'react'
import type { CrmIntegrationAttachment } from '../../types/crm-integration-chat.types'
import {
  attachmentFileDisplayName,
  attachmentFileHref,
  attachmentFileMetaLabel,
} from '../../lib/crmIntegrationAttachment'
import classes from '../../styles/crmIntegrationChat.module.css'

type CrmIntegrationIncomingFileProps = {
  att: CrmIntegrationAttachment
}

const CrmIntegrationIncomingFile: FC<CrmIntegrationIncomingFileProps> = ({
  att,
}) => {
  if (att.kind !== 'file' && att.kind !== 'unknown') {
    return null
  }

  const title = attachmentFileDisplayName(att)
  const metaLabel = attachmentFileMetaLabel(att)
  const href = attachmentFileHref(att)

  return (
    <div className={classes.bubbleAudioCard}>
      <div className={classes.bubbleAudioHeader}>
        <FileOutlined
          className={classes.bubbleDocIcon}
          aria-hidden
          onPointerEnterCapture={undefined}
          onPointerLeaveCapture={undefined}
        />
        <div className={classes.bubbleAudioMeta}>
          <span className={classes.bubbleAudioLabel}>{title}</span>
          {metaLabel ? (
            <span className={classes.bubbleAudioDuration}>{metaLabel}</span>
          ) : null}
        </div>
      </div>
      {href ? (
        <a
          className={classes.bubbleAttachmentLink}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          download={att.name ?? undefined}
        >
          Скачать
        </a>
      ) : (
        <span className={classes.bubbleAttachmentLink}>Файл недоступен</span>
      )}
    </div>
  )
}

export default CrmIntegrationIncomingFile
